import React from 'react';
import FinalTranscript from './ScribeFinalTranscript';
// eslint-disable-next-line react/no-multi-comp
class FinalTranscriptList extends React.Component {
    shouldComponentUpdate(nextProps) {
        const { transcriptsFinal, fontSize, theme, lang, speakers } = this.props;
        if (fontSize !== nextProps.fontSize ||
            theme !== nextProps.theme ||
            lang !== nextProps.lang ||
            speakers !== nextProps.speakers) {
            return true;
        }
        return transcriptsFinal.length !== nextProps.transcriptsFinal.length;
    }
    render() {
        const { currentPlatform, features, fontSize, lang, speakers, theme, transcripts, transcriptsFinal, user, electronCaptionMode, } = this.props;
        return transcriptsFinal.map((tid) => (React.createElement(FinalTranscript, { currentPlatform: currentPlatform, features: features, fontSize: fontSize, key: transcripts[tid].id, lang: lang, speaker: speakers[transcripts[tid].author], theme: theme, transcript: transcripts[tid], user: user, electronCaptionMode: electronCaptionMode })));
    }
}
export default FinalTranscriptList;
